import { render, staticRenderFns } from "./stockAllocationDetail.vue?vue&type=template&id=27b8ca94&scoped=true&"
import script from "./stockAllocationDetail.vue?vue&type=script&lang=js&"
export * from "./stockAllocationDetail.vue?vue&type=script&lang=js&"
import style0 from "./stockAllocationDetail.vue?vue&type=style&index=0&id=27b8ca94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8ca94",
  null
  
)

export default component.exports